import type { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function AuthorizationSelect({
  ariaLabel,
  className,
  items,
  onChange,
  value,
}: {
  ariaLabel: string;
  className?: string;
  items: Array<{ label: string; value: string | null }>;
  onChange: (value: string | null) => void;
  value: string | null;
}): React.ReactElement {
  return (
    <Select items={items} value={value} onValueChange={(next) => onChange(next as string | null)}>
      <SelectTrigger size="sm" aria-label={ariaLabel} className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="start" alignItemWithTrigger={false}>
        <SelectGroup>
          {items.map((item) => (
            <SelectItem key={item.value ?? "all"} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}

export function regionFilterItems(t: ReturnType<typeof useTranslation<"settings">>["t"]) {
  return [
    { label: t("amazonAuthorization.table.allRegions"), value: null },
    { label: t("sellerCentral.regions.na"), value: "na" },
    { label: t("sellerCentral.regions.eu"), value: "eu" },
    { label: t("sellerCentral.regions.fe"), value: "fe" },
  ];
}

export function statusFilterItems(
  t: ReturnType<typeof useTranslation<"settings">>["t"],
  labelKey: "adsFilter" | "spApiFilter",
  includeNotConnected = true,
) {
  const items = [
    { label: t(`amazonAuthorization.table.${labelKey}`), value: null },
    { label: t("amazonAuthorization.status.connected"), value: "connected" },
    { label: t("amazonAuthorization.status.attention"), value: "attention" },
  ];
  if (includeNotConnected) {
    items.splice(2, 0, {
      label: t("amazonAuthorization.status.notConnected"),
      value: "notConnected",
    });
  }
  return items;
}
